module.exports = __webpack_public_path__ + "img/2-3.e35f236c.png";